import router from "../router";

const COURIER_KEY_FLE = "FLE";

function validErrorData(res) {
  let results = res.data;
  let status = true;
  let msgError = null;
  let notices = null;
  let data = null;

  let msgToken = {
    tokenMiss: "พบปัญหาในการเชื่อมต่อ กรุณาติดต่อเจ้าหน้าที่ #020",
    tokenNotdecode: "พบปัญหาในการเชื่อมต่อ กรุณาติดต่อเจ้าหน้าที่ #021",
    tokenExpired: "พบปัญหาในการเชื่อมต่อ กรุณาติดต่อเจ้าหน้าที่ #022",
    // error Code 405
    tokenNotAllowed: "พบปัญหาในการเชื่อมต่อ กรุณาติดต่อเจ้าหน้าที่ #023",
  };
  let msgInput = {
    dateInputError: "รูปแบบวันที่ไม่ถูกต้อง #100",
    duplicateEmail: "อีเมล์นี้มีการใช้งานแล้ว กรุณาลองใหม่",
    loginNotExists: "อีเมล์ หรือ รหัสผ่าน ไม่ถูกต้อง",
    limitedError:
      "จำนวนพนักงานของท่านเกินสิทธิ์ สนใจเพิ่มสิทธิ์ กรุณาติดต่อฝ่ายขาย  065-5127894 (เวลา 9.00-18.00 น.)",
    courierAddName: "กรุณากรอกชื่อขนส่ง",
    shopIdMiss: "กรุณากรอกชื่อร้านค้า",
    shopExp: "กรุณาสมัครแพ็กเกจเพิ่ม",
    shopNotices: "กรุณาติดต่อเซลล์ที่ดูแล",
    costIsNull: "กรุณาเรทราคาประเภทพัสดุ",
    duplicateEmailandTel:
      "เลขบัตรประชาชนหรือเบอร์โทรศัพท์นี้มีการใช้งานแล้ว กรุณาลองใหม่",
    userNotAllowed: "ผู้ใช้ไม่ได้รับการอนุญาต",
    missingOrders: "ไม่พบข้อมูล หรือ ไม่สามารถแก้ไขรายการนี้ได้",
    weightGreaterOrEqualTen: "น้ำหนักควรมากกว่า หรือ เท่ากับ 10 กรัม",
    errorWeightOrDimension: "กรุณากรอกรายละเอียดพัสดุให้ถูกต้อง",
    priceNotfound: "ไม่สามารถคำนวณน้ำหนักหรือขนาด พัสดุนี้ได้",
    costNotUpdate: "รายการนี้ไม่ถูกแก้ไข เนื่องจากอยู่ในช่วงน้ำหนักเดิม",
    parcelDetailsNotNumeric: "กรุณากรอกรายละเอียดพัสดุเฉพาะตัวเลข",
    missingCourierCode: "รหัสขนส่งไม่ถูกต้อง (#3001)",
    cannotUpdateAdditionalService: "กรุณาอัพเดทบริการเสริมใหม่อีกครั้ง",
    updateDataCodIdentity: "กรุณาตรวจสอบข้อมูลยืนยันตัวตนฝั่ง SHIPPOP",
  };
  const errorCode = {
    KRYS_BRANCH_ID_NOT_FOUND:
      "กรุณาติดต่อเจ้าหน้าที่ร้านของคุณไม่มี Branch ID (KRYS)",
    KRYQ_BRANCH_ID_NOT_FOUND:
      "กรุณาติดต่อเจ้าหน้าที่ร้านของคุณไม่มี Branch ID (KRYQ)",
    DUPLICATED_TRACKING: "หมายเลขพัสดุนี้ถูกใช้งานแล้ว",
    TRACKING_NOT_FOUND: "ไม่พบหมายเลขพัสดุดังกล่าว",
    ERR_CONFIRM_BOOKING_FAIL:
      "เกิดข้อผิดพลาด ไม่สามารถสร้างรายการได้ (ระบบขนส่ง)",
  };
  let msgCreateOrder = {
    contactShippop:
      "ไม่สามารถสร้างรายการได้ เนื่องจากคุณมียอดค้างชำระ กรุณาติดต่อเจ้าหน้าที่ เพื่อดำเนินการ",
    fle99:
      "การสร้างรายการ Flash 9.9 ไม่สามารถดำเนินการได้ เนื่องจากเกินเวลาที่กำหนด (12.00 น.) กรุณาเปิดบิลใหม่ หรือ ลบรายการ Flash 9.9 ออกจากรายการสินค้า",
    popshopUpdate: "ระบบปิดปรับปรุงชั่วคราว",
  };

  const msgPickupError = {
    pickupAPILimitExceed:
      "ไม่สามารถเรียกขนส่งได้เนื่องจากคุณเรียกเกินจำนวนที่กำหนด กรุณาติดต่อเจ้าหน้าที่เพื่อดำเนินการ",
    pickupFail: "เรียกขนส่งไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
  };

  let msgRegisterCod = {
    permissionError:
      "กรุณาติดต่อเซลล์ที่ดูแล เนื่องจากการโอนคืน COD ไม่ได้เปิดใช้งานโอนตรงคืนลูกค้า",
    pendingConfirmError:
      "กรุณาติดต่อเจ้าหน้าที่ เนื่องจากข้อมูลที่สมัคร COD ยังไม่ได้รับการยืนยัน",
  };

  let msgTracking = {
    trackingError: "ไม่พบรายการหมายเลขพัสดุนี้ กรุณาตรวจสอบหมายเลขพัสดุ",
    orderError: "ไม่พบรายการ",
  };

  let msgCreateShopWallet = {
    emailError:
      "ไม่สามารถเพิ่มหรืออัพเดทร้านค้าได้ เนื่องจากรูปแบบอีเมลไม่ถูกต้อง กรุณาตรวจสอบอีกครั้ง",
  };

  let msgCreateOrderWallet = {
    balanceError:
      "ไม่สามารถสร้างรายการได้ เนื่องจากยอดเครดิตคงเหลือไม่เพียงพอ กรุณาเติมเครดิต",
  };

  let msgSearchShipmentQuick = {
    shopError:
      "ไม่สามารถสร้างรายการ Shipment ได้ เนื่องจากรหัสร้านค้านี้ไม่ตรงกับรหัสร้านค้าที่ลูกค้าเลือก",
  };

  let otherError = "กรุณาติดต่อเจ้าหน้าที่";

  if (results.status == false) {
    status = false;
    msgError = otherError;
    if (results.error && errorCode[results.error.code]) {
      msgError = results.error.msg || errorCode[results.error.code];
    }
    if (results.error == "missing shop id") {
      msgError = msgInput.shopIdMiss;
    }

    if (results.error == "Flash9.9 Promotion time expired") {
      msgError = msgCreateOrder.fle99;
    }

    if (results.error == "user not allowed") {
      msgError = msgInput.userNotAllowed;
    }

    if (results.error == "Shop expired") {
      msgError = msgInput.shopExp;
    }
    //error login
    if (results.error == "user not exists.") {
      msgError = msgInput.loginNotExist;
    }
    // shop exp
    if (results.error.notices == "Shop deactivate") {
      status = false;
      msgError = msgInput.shopNotices;
    }
    // missing params
    if (results.error && results.error.code === 3001) {
      status = false;
      msgError = msgInput.missingCourierCode;
    }
    if (results.error.code === "pickupAPILimitExceed") {
      status = false;
      msgError = msgPickupError.pickupAPILimitExceed;
    }
    if (results.error.code === "pickupFail") {
      status = false;
      msgError = msgPickupError.pickupFail;
    }
    //error login
    if (results.error == "user not exists.") {
      status = false;
      msgError = msgInput.loginNotExists;
    }

    if (results.error == "User is number exceeds the limit") {
      msgError = msgInput.limitedError;
    }
    // error create member
    if (results.error == "missing duplicate key") {
      msgError = msgInput.duplicateEmailandTel;
    }

    if (results.error == "weight must be greater than or equal to 10") {
      msgError = msgInput.weightGreaterOrEqualTen;
    }

    if (results.error == "please update additional service again") {
      msgError = msgInput.cannotUpdateAdditionalService;
    }

    if (results.error == "wait for update by pop-shop") {
      msgError = msgCreateOrder.popshopUpdate;
    }

    if (results.error == "price not found") {
      msgError = msgInput.priceNotfound;
    }

    if (results.error == "missing identity Error this account confirmed") {
      msgError = msgInput.updateDataCodIdentity;
    }

    if (results.message == "over weight || dimension") {
      msgError = msgInput.errorWeightOrDimension;
    }
    if (results.message == "parcel details not numeric") {
      msgError = msgInput.parcelDetailsNotNumeric;
    }

    if (
      [
        "shippop details not exists.",
        "order not exists.",
        "parcel can not update #02",
      ].includes(results.message) ||
      ["shippop details not exists.", "order not exists."].includes(
        results.error
      )
    ) {
      msgError = msgInput.missingOrders;
    }

    if (
      results.error == "cost is not update" ||
      results.message == "parcel is not update"
    ) {
      msgError = msgInput.costNotUpdate;
    }

    // missing cod
    if (results.error == "missing identity Error permission account") {
      msgError = msgRegisterCod.permissionError;
    }
    if (
      results.error == "missing identity Error this account pending confirm"
    ) {
      msgError = msgRegisterCod.pendingConfirmError;
    }

    // missing tracking
    if (results.error == "missing order tracking_code") {
      msgError = msgTracking.trackingError;
    }

    // search tracking 
    if (results.error.code == "ERROR_TRACKING_SHOP_NOT_FOUND") {
      msgError = msgSearchShipmentQuick.shopError;
    }

    // error shop wallet
    if (results.error.message == '"email" must be a valid email') {
      msgError = msgCreateShopWallet.emailError;
    }

    // error create order by wallet
    if (results.error.data == "insufficient balance to withdraw") {
      msgError = msgCreateOrderWallet.balanceError;
    }

    if (results.error.code == 'ERR_API_KEY_COURIER_NOT_AVAILABLE') {
      msgError = results.error.msg;
    }

    // missing params
    if (typeof results.error === "object" && results.error !== null) {
      if (results.error.error_code == "POP_CREATE_ORDER") {
        let errorCreateOrder = checkErrorCreateOrder(results.error.data);
        msgError = errorCreateOrder.msg;
        data = errorCreateOrder.data;
        // msgError = results.error.msg
      }
      if (typeof results.error.notices !== "undefined") {
        if (
          results.error.notices == "Error_Create_Order" &&
          typeof results.error.data !== "undefined" &&
          (results.error.data.length > 0 ||
            Object.keys(results.error.data).length > 0)
        ) {
          let errorCreateOrder = checkErrorCreateOrder(results.error.data);
          msgError = errorCreateOrder.msg;
          data = errorCreateOrder.data;
        }

        if (
          results.error.notices == "Error_Create_Order" &&
          results.error.data.length < 1 &&
          results.error.code == "502"
        ) {
          msgError = results.error.msg;
        }
      }

      if (results.error.code === 3001) {
        msgError = msgInput.missingCourierCode;
      }

      if (results.error.code === "pickupAPILimitExceed") {
        msgError = msgPickupError.pickupAPILimitExceed;
      }

      if (results.error.code === "pickupFail") {
        msgError = msgPickupError.pickupFail;
      }

      if (results.error.code === 3001) {
        msgError = msgInput.missingCourierCode;
      }

      if (results.error.code === "pickupAPILimitExceed") {
        msgError = msgPickupError.pickupAPILimitExceed;
      }

      if (results.error.code === "pickupFail") {
        msgError = msgPickupError.pickupFail;
      }
    }

    //error code 400
    if (results.error.code == 400) {
      if (results.error.message == "Error: Please Contact SHIPPOP") {
        status = false;
        msgError = msgCreateOrder.contactShippop;
      }
      if (results.error.type == "BadRequest") {
        status = false;
        msgError = checkValidate(results.error.notices);
      }
    }
    //error Token 401
    if (results.error.code == 401) {
      if (results.error.type == "Unauthorized") {
        if (results.error.notices == "Token not provided.") {
          status = false;
          msgError = msgToken.tokenMiss;
        }
        if (results.error.notices == "An error while decoding token.") {
          status = false;
          msgError = msgToken.tokenNotdecode;
        }
        if (results.error.notices == "Provided token is expired.") {
          status = false;
          msgError = msgToken.tokenExpired;
          notices = "token is expired";
        }
        // improve system
        if (results.error.notices == "Improve system") {
          router.push("/improve");
        }
      }
    }
    //error Token 405
    if (results.error.code == 405) {
      if (results.error.type == "Unauthorized") {
        if (results.error.notices == "METHOD NOT ALLOWED") {
          status = false;
          msgError = msgToken.tokenNotAllowed;
        }
      }
    }
    //error input date code 0
    if (results.error.code == 0) {
      if (results.error.type == "ErrorException") {
        if (results.error.msg == "Undefined offset: 1") {
          status = false;
          msgError = msgInput.dateInputError;
        }
      }
    }
    //error couriers rate "23000"
    if (results.error.code == "23000") {
      status = false;
      msgError = msgInput.costIsNull;
    }
    // =status lastIf
  }
  return {status: status, msg: msgError, notices: notices, data: data};
}

function checkErrorCreateOrder(data) {
  const errorCreateOrder = "ไม่สามารถสร้างรายการได้ กรุณาตรวจสอบข้อมูล";
  const errorDefault =
    "มีบางอย่างผิดปกติ กรุณาติดต่อเจ้าหน้าที่ #error_create_order 01";
  const createOrderCodError =
    "กรุณาติดต่อเจ้าหน้าที่ เนื่องจากไม่สามารถใช้บริการ COD ได้ กรุณายืนยันตัวใหม่";
  let listParcelError = {data: [], msg: errorCreateOrder};
  try {
    for (let indexOfParcel in data) {
      let getCourierfromIndex = Object.keys(data[indexOfParcel])[0];
      let detailError = data[indexOfParcel][getCourierfromIndex];

      if (
        data.message ==
          "Email address can not use cod service, plase register bank account and identity card" ||
        data.message == "Undefined email parameter"
      ) {
        listParcelError.msg = createOrderCodError;
      }

      if (data.message == "Error: Please Contact SHIPPOP") {
        listParcelError.msg = "กรุณาติดต่อเซลล์ที่ดูแล";
      }

      if(data[indexOfParcel] && data[indexOfParcel].code) {
        listParcelError.data.push({
          indexOfParcel: indexOfParcel,
          msg: data[indexOfParcel].msg
        });
      }else if (
        detailError != undefined 
        && detailError["available"] == false
      ) {
        listParcelError.data.push({
          indexOfParcel: indexOfParcel,
          msg: convertErrorMsgCreateOrder({
            minimum: detailError["minimum"],
            errorCode: detailError["err_code"],
            remark: detailError["remark"],
            courier_code: detailError["courier_code"],
          }),
        });
      }
    }
  } catch (err) {
    listParcelError.msg = errorDefault;
  }

  return listParcelError;
}

function convertErrorMsgCreateOrder(msg) {
  const errorMsg = {
    default: "รายการผิดพลาด",
    errorDefault: "ที่อยู่ไม่ถูกต้อง",
    errorDest: "ที่อยู่ปลายทางไม่ถูกต้อง/ขนส่งไม่รองรับที่อยู่ปลายทาง",
    errorOrigin: "ที่อยู่ต้นทางไม่ถูกต้อง/ขนส่งไม่รองรับที่อยู่ต้นทาง",
    errorCourierExpired: "ราคาขนส่งมีการเปลี่ยนแปลงกรุณาเลือกขนส่งใหม่",
  };
  const ERROR_DEFAULT = "ERR_DEFAULT";
  const ERR_DEST = "ERR_DEST";
  const ERR_ORIGIN = "ERR_ORIGIN";

  let response = "";
  if (msg.courier_code == COURIER_KEY_FLE && msg.remark == "Not allow cod") {
    response = "กรุณาติดต่อเจ้าหน้าที่ เนื่องจากร้านค้ายังไม่ได้เปิดระบบ COD";
  } else if (msg.courier_code == COURIER_KEY_FLE) {
    response = msg.remark;
  } else if (new RegExp(/ERR_MIN_ORDER_(\d)+/gi).test(msg.errorCode)) {
    response = "ขั้นต่ำ " + msg.minimum + " ชิ้น";
  } else {
    if (msg.errorCode == ERROR_DEFAULT) {
      response = errorMsg.errorDefault;
    } else if (msg.errorCode == ERR_DEST) {
      response = errorMsg.errorDest;
    } else if (msg.errorCode == ERR_ORIGIN) {
      response = errorMsg.errorOrigin;
    } else if (msg.remark) {
      response = msg.remark;
    } else {
      response = errorMsg.default;
    }
  }

  return response;
}

function checkValidate(data) {
  let msg = "";
  let prepend = "";
  let details = "";
  for (let key in data) {
    prepend = convertKeyValidateToMsg(key);
    for (let val of data[key]) {
      details += convertMsgValidate(val);
    }
    msg += prepend + ": " + details + " ";
    prepend = details = "";
  }

  return msg;
}
function convertMsgValidate(data) {
  let res;
  if (data == "validation.unique") {
    res = "มีผู้ใช้งานแล้ว ";
  } else if (data == "validation.email") {
    res = "รูปแบบ Email ไม่ถูกต้อง ";
  } else {
    let res = "เกิดข้อผิดพลาด";
  }
  return res;
}
function convertKeyValidateToMsg(data) {
  let res;
  if (data == "tax_id") {
    res = "เลขบัตรประชาชน";
  } else if (data == "tel") {
    res = "เบอร์โทรศัพท์";
  } else if (data == "email") {
    res = "Email";
  } else {
    res = "เกิดข้อผิดพลาด";
  }
  return res;
}
export default validErrorData;
